import { render } from "./breadcrumb.vue?vue&type=template&id=5f61aedc&scoped=true"
import script from "./breadcrumb.vue?vue&type=script&lang=js"
export * from "./breadcrumb.vue?vue&type=script&lang=js"

import "./breadcrumb.vue?vue&type=style&index=0&id=5f61aedc&lang=scss&scoped=true"

import exportComponent from "/Library/WebServer/Documents/pt/qizhonghui/frontend/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.13_vue@3.4.19_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f61aedc"]])

export default __exports__